/**
 * KOLDER UNIFIED ATC SYSTEM
 * Maneja: Modal + Upsell + Volume Pricing + Quick-Add + Quantity
 */

/* Normaliza los miles en precios CLP de tarjetas y carruseles ($1.390). */
(() => {
  const priceSelector = [
    '.product-item .price',
    '.product-item .price--regular',
    '.product-item .unit-price-measurement__price',
    '.kolder-card__price',
    '.kolder-card__compare-price',
    '.kolder-card-mp__price',
    '.kolder-card-mp__compare-price'
  ].join(',');

  function normalizePriceElement(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      const normalized = node.nodeValue.replace(/(\d),(?=\d{3}(?:\D|$))/g, '$1.');
      if (normalized !== node.nodeValue) node.nodeValue = normalized;
    });
  }

  function normalizeCardPrices(scope = document) {
    if (scope.nodeType === Node.ELEMENT_NODE && scope.matches(priceSelector)) normalizePriceElement(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(priceSelector).forEach(normalizePriceElement);
  }

  function startPriceNormalizer() {
    normalizeCardPrices(document);
    new MutationObserver(mutations => mutations.forEach(mutation => {
      if (mutation.type === 'characterData') normalizeCardPrices(mutation.target.parentElement);
      mutation.addedNodes.forEach(node => { if (node.nodeType === Node.ELEMENT_NODE) normalizeCardPrices(node); });
    })).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startPriceNormalizer, { once: true });
  else startPriceNormalizer();
  document.addEventListener('shopify:section:load', event => normalizeCardPrices(event.target));
})();

function kolderCartUrl(path) {
  const country = new URLSearchParams(window.location.search).get('country');
  if (!country) return path;
  return `${path}${path.includes('?') ? '&' : '?'}country=${encodeURIComponent(country)}`;
}

document.addEventListener('DOMContentLoaded', function () {
  // ====== Carrusel de galería ======
  const gallery = document.querySelector('.product-gallery__carousel');
  if (gallery) {
    const slides = gallery.querySelectorAll('.product-gallery__carousel-item');
    const prevButton = document.querySelector('.carousel-arrow--prev');
    const nextButton = document.querySelector('.carousel-arrow--next');
    let currentIndex = 0;

    function updateSlides() {
      slides.forEach((slide, index) => {
        slide.classList.toggle('is-selected', index === currentIndex);
      });
      const thumbs = document.querySelectorAll('.product-gallery__thumbnail');
      thumbs.forEach((thumb, idx) => {
        thumb.classList.toggle('is-nav-selected', idx === currentIndex);
      });
    }

    if (prevButton) prevButton.addEventListener('click', function () {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateSlides();
    });

    if (nextButton) nextButton.addEventListener('click', function () {
      currentIndex = (currentIndex + 1) % slides.length;
      updateSlides();
    });

    updateSlides();
  }
});

/* ======================= UNIFIED ATC SYSTEM ======================= */
(() => {
  if (window.__KOLDER_ATC_INIT__) return;
  window.__KOLDER_ATC_INIT__ = true;

  const MAX_QTY = 999;
  let LOCK = false;
  let currentLineKey = null;
  let currentQty = 1;
  let cartCache = null;
  let lastCartFetch = 0;

  // -------- Helpers --------
  const fmt = (cents) =>
    (cents / 100).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });

  function updateCartCount(cart) {
    const count = cart.item_count ?? 0;
    document.querySelectorAll('.header__cart-count, [data-cart-count], .cart-count-bubble')
      .forEach((el) => {
        el.textContent = count;
        el.style.display = '';
        if (count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
  }
  window.updateCartCount = updateCartCount;

  async function fetchCart(forceRefresh = false) {
    const now = Date.now();
    if (!forceRefresh && cartCache && (now - lastCartFetch) < 2000) {
      return cartCache;
    }
    try {
      if (window.KolderCartRequests) {
        cartCache = await window.KolderCartRequests.read();
      } else {
        const res = await fetch(kolderCartUrl('/cart.js'), { credentials: 'same-origin' });
        if (!res.ok) throw new Error('cart.js ' + res.status);
        cartCache = await res.json();
      }
      lastCartFetch = now;
      return cartCache;
    } catch (e) {
      return { items: [] };
    }
  }

  function forceModalPosition(modal) {
    if (!modal) return;
    const isMobile = window.innerWidth <= 640;
    modal.style.setProperty('position', 'fixed', 'important');
    modal.style.setProperty('z-index', '99999', 'important');
    modal.style.setProperty('width', isMobile ? '100%' : 'min(920px, 94vw)', 'important');
    modal.style.setProperty('max-height', isMobile ? '80vh' : '86vh', 'important');
    if (isMobile) {
      modal.style.setProperty('left', '0', 'important');
      modal.style.setProperty('right', '0', 'important');
      modal.style.setProperty('bottom', '0', 'important');
      modal.style.setProperty('top', 'auto', 'important');
      modal.style.setProperty('border-radius', '16px 16px 0 0', 'important');
    } else {
      modal.style.setProperty('top', '50%', 'important');
      modal.style.setProperty('left', '50%', 'important');
      modal.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
      modal.style.setProperty('border-radius', '14px', 'important');
    }
  }

  // ======== UPSELL ========
  let __UPS_CURRENT = 0;

  async function loadATCUpsell(productId) {
    const box = document.getElementById('atc-upsell');
    const row = document.getElementById('atc-upsell-row');
    if (!box || !row || !productId) return;

    const run = ++__UPS_CURRENT;
    row.innerHTML = '';
    box.hidden = true;

    try {
      const base = (window.routes && window.routes.productRecommendationsUrl) || '/recommendations/products';
      const url = `${base}.json?product_id=${productId}&limit=6`;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('recos_failed');

      const data = await res.json();
      if (run !== __UPS_CURRENT) return;

      const seen = new Set();
      const filtered = (data.products || []).filter(p => {
        const key = `${p.id}-${p.handle}`;
        if (p.id === productId) return false;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      const picks = filtered.slice(0, 3);

      for (const p of picks) {
        const img = (p.featured_image || '').replace(/(\.jpg|\.jpeg|\.png|\.webp)(\?.*)?$/i, '$1');
        const href = p.url || `/products/${p.handle}`;
        const card = document.createElement('div');
        card.className = 'atc-upsell-card';
        card.innerHTML = `
          <a href="${href}" class="img-wrap"><img loading="lazy" alt="${p.title || ''}" src="${img}"></a>
          <a href="${href}" class="t">${p.title || ''}</a>
          <div class="prices">
            <span class="p">${fmt(p.price)}</span>
            ${p.compare_at_price && p.compare_at_price > p.price ? `<span class="c">${fmt(p.compare_at_price)}</span>` : ''}
          </div>
          <a class="btn" href="${href}">Ver producto</a>
        `;
        row.appendChild(card);
      }

      if (picks.length) {
        box.hidden = false;
        row.className = `atc-upsell-row count-${picks.length}`;
      }
    } catch (e) {
      console.warn('Upsell error:', e);
    }
  }
  window.loadATCUpsell = loadATCUpsell;

  // -------- MODAL --------
  function openATCModal(item) {
    const img = (item.image || item.featured_image || '').replace(/(\.jpg|\.jpeg|\.png|\.webp)(\?.*)?$/i, '$1');
    currentLineKey = item.key || null;
    currentQty = item.quantity || 1;

    const elImg = document.getElementById('atc-img');
    if (elImg) { elImg.src = img; elImg.alt = item.product_title || item.title || ''; }

    const vEl = document.getElementById('atc-vendor');
    if (vEl) vEl.textContent = item.vendor || '';

    const tEl = document.getElementById('atc-title');
    if (tEl) tEl.textContent = item.product_title || item.title || '';

    const pEl = document.getElementById('atc-price');
    if (pEl) pEl.textContent = fmt(item.final_price ?? item.price ?? 0);

    const qInput = document.getElementById('atc-qty-input');
    if (qInput) {
      qInput.value = currentQty;
      qInput.min = 1;
      qInput.max = MAX_QTY;
    }

    // Chip "Agregado"
    const priceEl = document.getElementById('atc-price');
    if (priceEl && priceEl.parentElement) {
      let chip = priceEl.parentElement.querySelector('.atc-chip');
      if (!chip) {
        chip = document.createElement('span');
        chip.className = 'atc-chip';
        priceEl.parentElement.appendChild(chip);
      }
      chip.textContent = `Agregado (${item.quantity} ${item.quantity > 1 ? 'uds' : 'ud'})`;
    }

    // Badge sobre imagen
    const imgEl = document.getElementById('atc-img');
    if (imgEl && imgEl.parentElement) {
      imgEl.parentElement.style.position = 'relative';
      let badge = imgEl.parentElement.querySelector('.atc-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'atc-badge';
        badge.textContent = 'Agregado';
        imgEl.parentElement.appendChild(badge);
      }
    }

    // Anuncio accesibilidad
    let ariaLive = document.getElementById('atc-aria-live');
    if (!ariaLive) {
      ariaLive = document.createElement('div');
      ariaLive.id = 'atc-aria-live';
      ariaLive.setAttribute('role', 'status');
      ariaLive.setAttribute('aria-live', 'polite');
      ariaLive.className = 'visually-hidden';
      document.body.appendChild(ariaLive);
    }
    ariaLive.textContent = `${item.product_title || item.title} agregado al carrito.`;

    const m = document.getElementById('atc-modal');
    const o = document.getElementById('atc-overlay');
    if (!m || !o) return;

    if (o.parentElement !== document.body) document.body.appendChild(o);
    if (m.parentElement !== document.body) document.body.appendChild(m);

    forceModalPosition(m);
    m.hidden = false;
    o.hidden = false;
    requestAnimationFrame(() => { m.classList.add('show'); o.classList.add('show'); });
  }
  window.openATCModal = openATCModal;

  function closeATC() {
    const m = document.getElementById('atc-modal');
    const o = document.getElementById('atc-overlay');
    if (!m || !o) return;
    m.classList.remove('show');
    o.classList.remove('show');
    setTimeout(() => { m.hidden = true; o.hidden = true; }, 200);
  }

  async function setModalQty(q) {
    currentQty = q;
    const qInput = document.getElementById('atc-qty-input');
    if (qInput) qInput.value = q;
    if (!currentLineKey) return;

    try {
      const r = await fetch(kolderCartUrl('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: currentLineKey, quantity: q })
      });
      const cart = await r.json();
      updateCartCount(cart);

      if (q === 0) {
        currentLineKey = null;
        closeATC();
        return;
      }

      const line = cart.items.find(li => li.key === currentLineKey);
      if (line) {
        currentQty = line.quantity;
        if (qInput) qInput.value = currentQty;
        const chip = document.querySelector('.atc-chip');
        if (chip) chip.textContent = `Agregado (${currentQty} ${currentQty > 1 ? 'uds' : 'ud'})`;
      } else {
        closeATC();
      }
    } catch (e) {
      console.warn('Error actualizando cantidad', e);
    }
  }

  // -------- LISTENERS MODAL --------
  document.addEventListener('click', (e) => {
    if (e.target.id === 'atc-overlay' || e.target.closest('.atc-close') || e.target.closest('[data-atc="continue"]')) {
      closeATC();
    }
    if (e.target.closest('[data-atc="dec"]')) {
      e.preventDefault();
      setModalQty(Math.max(1, currentQty - 1));
    }
    if (e.target.closest('[data-atc="inc"]')) {
      e.preventDefault();
      setModalQty(Math.min(MAX_QTY, currentQty + 1));
    }
  });

  window.addEventListener('resize', () => {
    const m = document.getElementById('atc-modal');
    if (m && !m.hidden) forceModalPosition(m);
  });

// -------- CORE: AGREGAR AL CARRITO --------
async function addToCart(source) {
  if (LOCK) return;
  LOCK = true;
  setTimeout(() => (LOCK = false), 800);

  try {
    let variantId = null;
    let quantity = 1;
    let productId = null;

    // Caso 1: String/Number = variant ID directo (quick-add)
    if (typeof source === 'string' || typeof source === 'number') {
      variantId = String(source);
      quantity = 1;
    }
    // Caso 2: Form de producto
    else if (source && source.querySelector) {
      const form = source;
      const baseVariantId = form.querySelector('input[name="id"]')?.value;
      
      // NUEVA ESTRATEGIA: Buscar input visible más confiable
      let qtyInput = null;
      
      // Método 1: Buscar por clase específica del tema
      qtyInput = document.querySelector('.product-form__info-item--quantity .quantity-selector__value');
      
      // Método 2: Verificar que está visible
      if (qtyInput && (qtyInput.offsetParent === null || qtyInput.closest('[hidden]'))) {
        qtyInput = null;
      }
      
      // Método 3: Buscar cualquier quantity-selector visible del producto principal
      if (!qtyInput) {
        const allVisible = Array.from(document.querySelectorAll('.quantity-selector__value'))
          .filter(input => 
            input.offsetParent !== null && 
            !input.closest('#atc-modal') &&
            !input.closest('.sticky-qty-mobile') &&
            !input.closest('[hidden]')
          );
        
        if (allVisible.length > 0) {
          qtyInput = allVisible[0];
        }
      }
      
      const selectedQty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;
      

      // Detectar product ID
      productId = form.closest('[data-product-id]')?.dataset.productId ||
        document.querySelector('[data-section-type="product"]')?.getAttribute('data-section-id')?.match(/product-(\d+)/)?.[1];

      // Iniciar con variant base y cantidad seleccionada
      variantId = baseVariantId;
      quantity = selectedQty;

      // Si hay Volume Pricing, ajustar SOLO el variant_id (no la cantidad)
      if (typeof window.__getVolumeTier === 'function' && productId) {
        const cart = await fetchCart(true);
        const inCart = cart.items
          .filter(i => String(i.product_id) === String(productId))
          .reduce((sum, i) => sum + i.quantity, 0);

        const totalAfterAdd = selectedQty + inCart;
        const tier = window.__getVolumeTier(productId, totalAfterAdd);

        if (tier?.variant_id) {
          variantId = tier.variant_id;
        }
      }
    }

    if (!variantId) throw new Error('No variant ID');


    // Agregar
    const addRes = await fetch(kolderCartUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    
    if (!addRes.ok) throw new Error('add_failed');
    const item = await addRes.json();


    // Reconciliar carrito
    if (typeof window.__reconcileCart === 'function' && productId) {
      await window.__reconcileCart(productId);
    }

    // Actualizar carrito
    cartCache = null;
    const cartRes = await fetch(kolderCartUrl('/cart.js'), { headers: { 'Accept': 'application/json' } });
    const cart = await cartRes.json();
    updateCartCount(cart);

    // Buscar línea actualizada
    const line = cart.items.find(li => 
      li.key === item.key || 
      li.variant_id === item.variant_id ||
      String(li.product_id) === String(productId)
    );
    
    if (line) {
      item.quantity = line.quantity;
      item.product_id = line.product_id;
      item.key = line.key;
    }

    // Eventos
    document.dispatchEvent(new CustomEvent('product:added', { detail: item }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch (err) {
    console.error('[custom.js] Error agregando:', err);
    alert('No se pudo agregar el producto. Intenta nuevamente.');
  }
}

// -------- CAPTURA UNIVERSAL --------
document.addEventListener('click', (e) => {
  const btn = e.target.closest(`
    .product-form__add-button,
    button[name="add"],
    [data-action="add-to-cart"],
    .quick-add-button,
    [data-quick-add],
    .btn--add-to-cart,
    .kolder-card-mp__button
  `.trim());

  if (!btn) return;
  
  // EXCLUIR el botón del producto principal (tiene su propio handler)
  if (btn.hasAttribute('data-action') && btn.getAttribute('data-action') === 'add-to-cart-custom') {
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = 'Agregando…';

    // Quick-add directo
    const directVariantId = btn.getAttribute('data-variant-id') ||
      btn.getAttribute('onclick')?.match(/agregarAlCarrito\((\d+)/)?.[1];

    if (directVariantId) {
      addToCart(directVariantId).finally(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
      return;
    }

    // Form
    const form = btn.closest('form.product-form, form[action*="/cart/add"]');
    if (form) {
      addToCart(form).finally(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
      return;
    }

    // Fallback
    const idInput = document.querySelector('input[name="id"]');
    if (idInput?.value) {
      addToCart(idInput.value).finally(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
    } else {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  }, true);

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.product-form, form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const btn = form.querySelector('.product-form__add-button, button[name="add"]');
    if (btn) {
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Agregando…';

      addToCart(form).finally(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
    } else {
      addToCart(form);
    }
  }, true);

})();

/* ===== FIX QUANTITY EN CARRITO ===== */
(() => {
  if (window.__CART_QTY__) return;
  window.__CART_QTY__ = true;

  async function refreshCartSection() {
    const sectionEl = document.querySelector('section[data-section-type="cart"]');
    const sectionId = sectionEl?.dataset.sectionId;
    if (!sectionId) return;

    const url = `${location.pathname}?section_id=${encodeURIComponent(sectionId)}`;
    const html = await fetch(url).then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSection = doc.querySelector(`section[data-section-id="${sectionId}"]`);
    const oldWrap = sectionEl.querySelector('.cart-wrapper');
    const newWrap = newSection?.querySelector('.cart-wrapper');

    if (newWrap && oldWrap) {
      oldWrap.replaceWith(newWrap);
    } else if (newSection) {
      sectionEl.outerHTML = newSection.outerHTML;
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })
    );
  }

  async function changeLine(line, quantity) {
    try {
      const res = await fetch(kolderCartUrl('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      
      if (!res.ok) throw new Error('Cart change failed');
      
      const cart = await res.json();
      if (window.updateCartCount) window.updateCartCount(cart);
      await refreshCartSection();
    } catch(e) {
      console.error('Error changing quantity:', e);
      alert('No se pudo actualizar la cantidad. Intenta nuevamente.');
    }
  }

  // Delegación de eventos para + y -
  document.addEventListener('click', (e) => {
    // Ignorar clicks dentro del modal ATC
    if (e.target.closest('#atc-modal')) return;

    const increase = e.target.closest('[data-action="increase-quantity"]');
    const decrease = e.target.closest('[data-action="decrease-quantity"]');
    const remove = e.target.closest('.line-item__quantity-remove');

    if (!increase && !decrease && !remove) return;

    e.preventDefault();
    e.stopPropagation();

    // Remover
    if (remove && remove.dataset.quantity === '0') {
      const line = parseInt(remove.dataset.line, 10);
      if (line) changeLine(line, 0);
      return;
    }

    const btn = increase || decrease;
    const line = parseInt(btn.dataset.line, 10);
    const targetQty = parseInt(btn.dataset.quantity, 10);
    
    if (!line || isNaN(targetQty)) return;

    changeLine(line, Math.max(0, targetQty));
  });

  // Input directo
  document.addEventListener('change', (e) => {
    if (e.target.closest('#atc-modal')) return;
    
    const input = e.target.closest('.quantity-selector__value');
    if (!input || !input.dataset.line) return;

    e.stopPropagation();
    const line = parseInt(input.dataset.line, 10);
    if (!line) return;

    const val = Math.max(0, parseInt(input.value || '1', 10));
    if (String(val) !== input.value) input.value = String(val);
    
    changeLine(line, val);
  });
})();

/* ===== OCULTAR OPCIÓN VOLUMEN (MEJORADO) ===== */
(() => {
  if (window.__VOLUME_HIDE_INIT__) return;
  window.__VOLUME_HIDE_INIT__ = true;

  function hideVolumeOption() {
    const blocks = document.querySelectorAll(`
      .product-option,
      .product-form__option,
      fieldset.product-form__input,
      .variant-input-wrap,
      [data-selector-type],
      div[class*="option"]
    `.trim());
    
    blocks.forEach(block => {
      const labelEl = block.querySelector(`
        .product-form__option-name,
        .product-option__name,
        legend,
        label,
        .variant-input__label-text,
        span.text--strong
      `.trim());
      
      const labelText = (labelEl?.textContent || '').toLowerCase().trim();
      
      const valueElements = block.querySelectorAll(`
        input,
        button,
        option,
        .variant-input__radio-label,
        .block-swatch__item-text,
        label
      `.trim());
      
      const valuesText = Array.from(valueElements)
        .map(el => {
          const text = el.value || el.textContent || el.getAttribute('aria-label') || el.getAttribute('title') || '';
          return text.toLowerCase().trim();
        })
        .join(' ');
      
      const hasVolumePattern = 
        labelText.includes('volumen') || 
        labelText.includes('dcto') ||
        labelText.includes('descuento') ||
        labelText.includes('cantidad') ||
        labelText.includes('precio por') ||
        (valuesText.includes('unidades') && (
          valuesText.match(/\d+\s*-\s*\d+/) ||
          valuesText.includes('kilo:') ||
          valuesText.includes('10+') ||
          valuesText.includes('20+') ||
          valuesText.includes('40+') ||
          valuesText.includes('100+')
        ));
      
      if (hasVolumePattern) {
        block.setAttribute('hidden', '');
        block.classList.add('visually-hidden', 'volume-option-hidden');
        block.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important;';
      }
    });
  }

  // Ejecutar una vez al inicio
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideVolumeOption);
  } else {
    hideVolumeOption();
  }

  // Observer solo en el formulario de producto (no en todo el body)
  const productForm = document.querySelector('.product-form, [data-product-form], variant-picker');
  if (productForm) {
    const observer = new MutationObserver(hideVolumeOption);
    observer.observe(productForm, {
      childList: true,
      subtree: true
    });
  }

  // Escuchar eventos del tema cuando cambia la variante
  document.addEventListener('variant:change', hideVolumeOption);
  document.addEventListener('product:variant:change', hideVolumeOption);
  document.addEventListener('shopify:section:load', hideVolumeOption);

  window.hideVolumeOption = hideVolumeOption;
})();

